import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type OloConfig = definitions['olo.Config']

const service = {
  getConfig: coreService['POS:GET:OloConfig'],
  updateThrottlingInfo: coreService['POS:PUT:OloConfig.ThrottlingInfo'],
};

export default service;
export type { OloConfig };
